export const PRODUCT_GROUP = 'ProductGroup';
/** Maximum depth of the product-group tree (root = level 1). */
export const PRODUCT_GROUP_MAX_DEPTH = 4;
/**
 * Fields a child **inherits on create** from its parent and may change afterwards.
 * Keep this list the single place to extend when new "default from parent" fields appear.
 * Never propagates parent edits to existing children.
 */
export const PRODUCT_GROUP_INHERITED_FIELDS = ['productType'];
export var ProductType;
(function (ProductType) {
    ProductType["BASIC"] = "Basic";
    ProductType["TEXTIL"] = "Textil";
})(ProductType || (ProductType = {}));
/** Separator between descriptions in {@link ProductGroup.pathDescription}. */
export const PRODUCT_GROUP_PATH_DESCRIPTION_SEP = ' › ';
/**
 * Fills {@link PRODUCT_GROUP_INHERITED_FIELDS} on `draft` from `parent` only when the
 * draft still has those fields unset (`undefined`). Does not overwrite user choices.
 */
export function inheritFromParent(parent, draft) {
    const result = { ...draft };
    for (const field of PRODUCT_GROUP_INHERITED_FIELDS) {
        if (result[field] === undefined) {
            result[field] = parent[field];
        }
    }
    return result;
}
/** Effective materialized path — legacy rows without `path` behave as root. */
export function effectiveProductGroupPath(group) {
    const path = group.path?.trim();
    return path ? path : group.id;
}
/** Effective level — legacy rows without `level` are root (1). */
export function effectiveProductGroupLevel(group) {
    if (typeof group.level === 'number' && Number.isFinite(group.level) && group.level >= 1) {
        return group.level;
    }
    return effectiveProductGroupPath(group).split('/').filter(Boolean).length || 1;
}
/** Display path — falls back to `description` for legacy rows. */
export function effectiveProductGroupPathDescription(group) {
    const pathDescription = group.pathDescription?.trim();
    return pathDescription ? pathDescription : group.description;
}
/** True when `candidatePath` is `ancestorPath` or a descendant under it. */
export function isProductGroupPathUnder(candidatePath, ancestorPath) {
    return candidatePath === ancestorPath || candidatePath.startsWith(`${ancestorPath}/`);
}
/**
 * Builds hierarchy fields for a group given its parent (or root) and the
 * descriptions of every id on the resulting path (including self).
 */
export function buildProductGroupHierarchy(args) {
    const { id, description, parent, descriptionById } = args;
    const path = parent ? `${effectiveProductGroupPath(parent)}/${id}` : id;
    const level = parent ? effectiveProductGroupLevel(parent) + 1 : 1;
    const ids = path.split('/').filter(Boolean);
    const pathDescription = ids
        .map((segmentId) => {
        if (segmentId === id)
            return description;
        return descriptionById.get(segmentId) ?? segmentId;
    })
        .join(PRODUCT_GROUP_PATH_DESCRIPTION_SEP);
    return { path, level, pathDescription };
}
//# sourceMappingURL=product-group.js.map